module.exports = __webpack_public_path__ + "img/successCheckIcon.4b230ff8.svg";